import { useTranslation } from 'react-i18next'

import { useTheme } from 'styled-components'

import { Alert, Card, CardTitle } from '@reveni-io/reveni-ui'

import YourEarningsCardSkeleton from './YourEarningsCardSkeleton/YourEarningsCardSkeleton'
import YourEarningsContent from './YourEarningsContent/YourEarningsContent'

const YourEarningsCard = ({ earnings, loading, error }) => {
  const theme = useTheme()
  const { t } = useTranslation()

  if (loading) return <YourEarningsCardSkeleton />

  if (error) {
    return (
      <Card>
        <CardTitle marginBottom={theme.spacing.sp16}>{t('Tus ganancias')}</CardTitle>
        <Alert type="error">{t('No se han podido cargar los datos. Inténtalo de nuevo.')}</Alert>
      </Card>
    )
  }

  return (
    <Card>
      <CardTitle marginBottom={theme.spacing.sp16}>{t('Tus ganancias')}</CardTitle>
      <YourEarningsContent earnings={earnings} />
    </Card>
  )
}

export default YourEarningsCard
